<template>
    <div></div>
</template>

<script>
import AboveEntryForm from './AboveEntryForm.js';
export default AboveEntryForm;
</script>
